import React, { PureComponent } from 'react';
import { withStyles, Zoom, Fab, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';

import AddIcon from '@material-ui/icons/Add';
import ActivityIndicator from '../../shared/ActivityIndicator';

class FabButton extends PureComponent {
  state = {
    open: false
  };

  toggleOpen = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  render() {
    const { classes, actions, loading } = this.props;
    const { open } = this.state;

    return (
      <div className={classes.container}>
        <div className={classes.actionsContainer}>
          {actions.map(action => (
            <Zoom in={open} key={action.name}>
              <div className={classes.actionItem}>
                <Tooltip title={action.name} placement="left">
                  <Fab
                    size="small"
                    color="secondary"
                    onClick={action.action}
                    className={classes.actionButton}
                  >
                    {loading ? (
                      <ActivityIndicator
                        size={16}
                        color="white"
                        className={classes.loading}
                      />
                    ) : (
                      action.icon
                    )}
                  </Fab>
                </Tooltip>
              </div>
            </Zoom>
          ))}
        </div>

        <Fab color="primary" onClick={this.toggleOpen}>
          <AddIcon />
        </Fab>
      </div>
    );
  }
}

const styles = {
  container: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '12px'
  },
  actionItem: {
    marginBottom: '10px'
  },
  actionButton: {
    boxShadow: '0 3px 5px rgba(0,0,0,0.3)'
  }
};

FabButton.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      name: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired
    })
  ).isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(FabButton);
